import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Case } from 'src/app/case-manager/models/casehistory';
import { CaseManagerChange } from 'src/app/case-manager/models/changeCaseManager';
import { NursingNote } from 'src/app/case-manager/models/nursingNote';
import { SearchCaseRequest } from 'src/app/case-manager/models/searcCaseRequest';
import { BaseService } from '../shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class CaseManagementService {

  constructor(private baseService: BaseService) {}

  getCaseList(req: SearchCaseRequest): Observable<any> {
    return this.baseService.post(
      `CaseManagement/GetCaseList`,
      req
    );
  }

  saveCase(req: Case): Observable<any> {
    console.log(req);
    if(!req.id){
    return this.baseService.post<any>(
      `CaseManagement/AddCase`,
      req
    );
    }else{
      return this.baseService.post<any>(
        `CaseManagement/UpdateCase`,
        req
      );
    }
  }
  
  
  changeCaseManager(req: CaseManagerChange): Observable<any> {
   
      return this.baseService.post<any>(
        `CaseManagement/ChangeCaseManager`,
        req
      );
   
  }
  uploadCaseDocument(
    caseId: number,
    file: any
  ): Observable<any> {
    const docForm: FormData = new FormData();
    docForm.append("File", file, file.name);
    docForm.append("caseId", caseId.toString());

    return this.baseService.upload<any>(
      `CaseManagement/UploadCaseDocument`,
      docForm
    );
  }
  getCaseDocuments(caseId: number): Observable<any> {
    return this.baseService.get(
      `CaseManagement/GetCaseDocuments?caseId=${caseId}`     
    );
  }
  
  getCaseNursingNotes(caseId: number): Observable<any> {
    return this.baseService.get(
      `CaseManagement/GetCaseNursingNotes?caseId=${caseId}`     
    );
  }
  addNursingNote(req: NursingNote): Observable<any> {
    return this.baseService.post<any>(
      `CaseManagement/AddNursingNote`,
      req
    );
  }
  editNursingNote(req: NursingNote): Observable<any> {
    return this.baseService.post<any>(
      `CaseManagement/UpdateNursingNote`,
      req
    );
  }
  deleteNursingNote(noteId: number): Observable<any> {   
    return this.baseService.post<any>(
      `CaseManagement/DeleteNursingNote?caseNursingNoteId=${noteId}` ,
     {}
    );

}
  getTotalCasesForDashboard(casemanagerId:number): Observable<any> {
    return this.baseService.get(
      `CaseManagement/GetTotalCasesForDashboard?casemanagerId=${casemanagerId}`     
    );
  }
  getCases(casemanagerId:number): Observable<any> {
    return this.baseService.get(
      `CaseManagement/GetCases?casemanagerId=${casemanagerId}`     
    );
  }
  
  deleteCaseDocument(casedocId: number): Observable<any> {   
      return this.baseService.post<any>(
        `CaseManagement/DeleteCaseDocument?caseDocumentId=${casedocId}` ,
       {}
      );
  
  }
  
}
